import React, { useState, useContext, useRef, useEffect } from 'react';
import { Canvas } from '@react-three/fiber';
import Sphere from './Sphere';
import { StateProvider, StateContext } from './StateContext';
import { Stars } from '@react-three/drei';

const AppContent = () => {
  const [left, setLeft] = useState(0);
  const { targetCity } = useContext(StateContext);
  const sphereRef = useRef();
  const [isHidden, setIsHidden] = useState(true);
  const [isVisible, setIsVisible] = useState(!isHidden);

useEffect(() => {
  if (isHidden) {
    setTimeout(() => setIsVisible(false), 2000); // Wait for fade-out to complete
  } else {
    setIsVisible(true); // Show immediately for fade-in
  }
}, [isHidden]);

  const leftValue = (newValue) => {
    setLeft(newValue);
  };

  const handleExit = () => {
    if (sphereRef.current && targetCity) {
      sphereRef.current.handleExit(targetCity);
    }
    setIsHidden(true);
    console.log(targetCity);
  };

  useEffect(() => {
    if (targetCity) {
      setIsHidden(false);
    }
  }, [targetCity]);

  const buttonStyle = {
    zIndex: 9999,
    position: 'absolute',
    right: 20,
    top: 20,
    padding: '10px 20px',
    backgroundColor: '#f44336',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    fontSize: '16px',
    transition: 'background-color 0.3s ease',
  };

  const descriptionStyle = {
    zIndex: 9999,
    position: 'absolute',
    left: 500,
    right: 500,
    top: 400,
    padding: '10px 20px',
    color: 'white',
    fontSize: '16px',
    opacity: isHidden ? 0 : 1,
    visibility: isHidden ? 'hidden' : 'visible',
    transform: isHidden ? 'translateY(20px)' : 'translateY(0)',
    transition: isHidden 
      ? 'opacity 1s ease, transform 1s ease, visibility 1s'  // Faster hide
      : 'opacity 3s ease, transform 3s ease, visibility 3s',  // Slower display
  };
  

  const hoverStyle = {
    backgroundColor: '#d32f2f',
  };

  return (
    <div style={{ width: '100vw', height: '100vh', backgroundColor: "#02010e" }}>
      <Canvas
        style={{
          position: 'absolute',
          left: `${left}px`,
          zIndex: 0,
          transition: 'left 1.5s ease-in-out',
        }}
      >
        <ambientLight intensity={0.5} />
        <directionalLight position={[5, 5, 5]} />
        <Sphere ref={sphereRef} leftValue={leftValue} />
      </Canvas>

      <div className="city-description" style={descriptionStyle}>
        <h1>{targetCity ? targetCity.city : "" }</h1>
      {targetCity ? targetCity.description : ""}
      </div>

      {left === -1000 && (
        <button
          onClick={handleExit}
          style={buttonStyle}
          onMouseEnter={(e) => e.target.style.backgroundColor = hoverStyle.backgroundColor}
          onMouseLeave={(e) => e.target.style.backgroundColor = buttonStyle.backgroundColor}
        >
          X
        </button>
      )}
    </div>
  );
};

const App = () => (
  <StateProvider>
    <AppContent />
  </StateProvider>
);

export default App;
